import { VisitDetails } from '@va/dashboard/components';
import { InteractivePageUrl } from '@va/dashboard/shared/pages';
import { useTranslate } from '@va/localization';
import { Favicon, Paragraph, fontWeights, paragraphSizes } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { getWellFormedUrl } from '@va/util/helpers';
import { useIsFocused } from '@va/util/hooks';
import classNames from 'classnames';

import React, { useRef } from 'react';

type ReferrerCellProps = {
  referrer: string | null;
  size?: 'small' | 'medium';
  squareIcon?: boolean;
  color?: string;
};

export const ReferrerCell: React.FC<ReferrerCellProps> = ({ referrer, size = 'medium', squareIcon, color }) => {
  const translate = useTranslate();
  const referrerUrlRef = useRef<HTMLAnchorElement>(null);
  const isFocused = useIsFocused(referrerUrlRef);

  return (
    <div
      className={classNames('w-full flex items-center justify-start', {
        'gap-2': size === 'medium',
        'gap-1.5': size === 'small',
      })}
    >
      <div className='relative'>
        <VisitDetails
          icon={<Favicon size={size} baseUrl={referrer ? `${getWellFormedUrl(referrer)}` : undefined} />}
          size={size}
          squareIcon={squareIcon}
        />
        {color && (
          <div
            style={{ backgroundColor: color }}
            className='absolute rounded-full w-3 h-3 border border-white right-0 bottom-0'
          />
        )}
      </div>

      {referrer ? (
        <InteractivePageUrl pageUrl={referrer} className='font-medium text-12 text-text-secondary' isExternal />
      ) : (
        <TooltipWrapper content={translate('all.recordings.referrer.directVisitsTooltip')}>
          <Paragraph
            size={paragraphSizes.tiny}
            weight={fontWeights.medium}
            colorClassName='text-text-secondary'
            className='text-left'
          >
            {translate('all.recordings.referrer.directVisits')}
          </Paragraph>
        </TooltipWrapper>
      )}
    </div>
  );
};
